module.exports = __webpack_public_path__ + "media/intro_aful2_1080p.af70a01d.webm";